/**
 * Generates a time-based greeting message for a user
 * @param fullName - The user's full name
 * @returns A greeting message based on the current local time using only the first name
 */
export const getTimeBasedGreeting = (fullName: string): string => {
  const now = new Date();
  const hour = now.getHours();

  // Extract the first name from the full name
  const firstName = fullName.split(" ")[0];

  if (hour >= 5 && hour < 12) {
    return `Good morning, ${firstName}`;
  }
  if (hour >= 12 && hour < 17) {
    return `Good afternoon, ${firstName}`;
  }
  return `Good evening, ${firstName}`;
};
